<section class="request__cpe__filter">
  <div class="request__container">
    <form [formGroup]="viewModel.cpeForm" (ngSubmit)="onSubmit()">
      <h2 color="black">Qual é o critério de pesquisa?</h2>
      <div class="first-dsm3__ul">
        <div class="first-dsm3__li">
          <label class="first-dsm3__li-box-span">
            <input class="first-dsm3__input-radio" formControlName="way" name="way" type="radio" value="zip" />
            <span class="first-dsm3__li-span">Código Postal</span>
          </label>
        </div>
        <div class="first-dsm3__li">
          <label class="first-dsm3__li-box-span">
            <input class="first-dsm3__input-radio" formControlName="way" name="way" type="radio" value="address" />
            <span class="first-dsm3__li-span">Morada</span>
          </label>
        </div>
        <div class="first-dsm3__li">
          <label class="first-dsm3__li-box-span">
            <input class="first-dsm3__input-radio" formControlName="way" name="way" type="radio" value="counter" />
            <span class="first-dsm3__li-span">Contador</span>
          </label>
        </div>
      </div>

      <div class="request__cpe__filter__form" *ngIf="f.way.value === 'zip'">
        <div class="request__cpe__filter__form-zipcode" *ngIf="f.zipcode">
          <scc-dsm3-input-control
            [formGroup]="viewModel.cpeForm"
            formName="zipcode"
            type="text"
            [mask]="'XXXX-XXX'"
            placeholder="Código Postal"
            [label]="'1234-567'"
            maxlength="8"
            [errorsMessage]="{ required: 'Campo obrigatório.' }"
          >
          </scc-dsm3-input-control>
        </div>

        <div class="request__cpe__filter__form-group">
          <div class="frequest__cpe__filter__form-group-door" *ngIf="f.door">
            <scc-dsm3-input-control
              [formGroup]="viewModel.cpeForm"
              formName="door"
              type="text"
              placeholder="Nº da porta"
              (focusout)="onFocusOutEvent()"
              maxlength="8"
              [errorsMessage]="{ required: 'Campo obrigatório.' }"
            >
            </scc-dsm3-input-control>
          </div>

          <div class="request__cpe__filter__form-group-floor" *ngIf="f.floor">
            <scc-dsm3-select-control
              [formGroup]="viewModel.cpeForm"
              formName="floor"
              placeholder="Andar"
              [options$]="viewModel.floorList$"
              [errorsMessage]=""
            >
            </scc-dsm3-select-control>
          </div>

          <div class="request__cpe__filter__form-group-nif" *ngIf="f.nif">
            <scc-dsm3-input-control
              [formGroup]="viewModel.cpeForm"
              formName="nif"
              type="text"
              placeholder="NIF"
              maxlength=""
              [errorsMessage]=""
            >
            </scc-dsm3-input-control>
          </div>
        </div>
      </div>

      <div class="new-graphic-line" *ngIf="f.way.value === 'address'">
        <div class="form-group">
          <div class="counter-options">
            <scc-dsm3-radio-dropdown-control
              class="district"
              *ngIf="f.district"
              [formGroup]="viewModel.cpeForm"
              formName="district"
              [options$]="viewModel.districtList$"
              placeholder="Distrito"
              btnFilterLabel="Aplicar"
            >
            </scc-dsm3-radio-dropdown-control>

            <scc-dsm3-radio-dropdown-control
              class="county"
              *ngIf="f.county"
              [formGroup]="viewModel.cpeForm"
              formName="county"
              [options$]="viewModel.countyList$"
              placeholder="Concelho"
              btnFilterLabel="Aplicar"
            >
            </scc-dsm3-radio-dropdown-control>
          </div>
        </div>
        <div class="form-group">
          <div class="counter-options">
            <scc-dsm3-autocomplete-dropdown-control
              class="street"
              *ngIf="f.street"
              [formGroup]="viewModel.cpeForm"
              formName="street"
              placeholder="Rua"
              [options$]="viewModel.streetList$"
              [errorsMessage]="{ required: 'O campo é obrigatório' }"
            >
            </scc-dsm3-autocomplete-dropdown-control>

            <scc-dsm3-input-control
              class="door"
              *ngIf="f.door"
              [formGroup]="viewModel.cpeForm"
              formName="door"
              type="text"
              placeholder="Nº da porta"
              maxlength="8"
              [errorsMessage]="{ required: 'Insira nº de porta' }"
            >
            </scc-dsm3-input-control>

            <scc-dsm3-select-control
              *ngIf="f.floor"
              class="floor"
              [formGroup]="viewModel.cpeForm"
              formName="floor"
              placeholder="Andar"
              [textMask]="{ mask: false }"
              [options$]="viewModel.floorList$"
              [errorsMessage]=""
            >
            </scc-dsm3-select-control>
          </div>
        </div>
        <div class="form-group">
          <div class="counter-options" *ngIf="f.nif">
            <scc-dsm3-input-control
              class="nif"
              [formGroup]="viewModel.cpeForm"
              formName="nif"
              type="text"
              placeholder="NIF"
              [errorsMessage]="{ required: 'Insira NIF' }"
            >
            </scc-dsm3-input-control>
          </div>
        </div>
      </div>

      <div class="new-graphic-line" *ngIf="f.way.value === 'counter'">
        <div class="form-group counter-options" *ngIf="f.counter">
          <scc-dsm3-radio-dropdown-control
            class="counter"
            [options$]="viewModel.counterList$"
            [formGroup]="viewModel.cpeForm"
            formName="counter"
            placeholder="Contador"
            (onClear)="onDropdownClear()"
            btnFilterLabel="Aplicar"
          >
          </scc-dsm3-radio-dropdown-control>

          <scc-dsm3-input-control
            class="reference"
            [formGroup]="viewModel.cpeForm"
            formName="reference"
            placeholder="Referência contador"
            [errorsMessage]="{ required: 'O campo é obrigatório' }"
          >
          </scc-dsm3-input-control>
        </div>
      </div>
      <div class="new-graphic-line">
        <div class="form-group declaration">
          <div class="checkbox-wrapper checkbox-column">
            <input
              type="checkbox"
              formControlName="acceptTerms"
              [attr.value]="viewModel.declarationsTerms"
              [attr.checked]="viewModel.declarationsTerms"
              (change)="onChecked($event)"
              class="dsm3__input-checkbox"
            />

            Declara que solicita a consulta/disponibilização do respetivo Código do Ponto de Entrega (CPE) da instalação
            no exclusivo interesse e em representação do cliente que pretende celebrar contrato de fornecimento de
            eletricidade associado ao/à Código Postal/Morada/Equipamento de medição acima indicado, enquanto entidade
            interessada, nos termos do disposto n.º 1 do artigo 237.º do Regulamento das Relações Comerciais do Setor
            Elétrico, à qual deve ser divulgado o respetivo CPE.
            <br />
            <br />
            Caso venha a ser solicitada evidência da autorização subscrita pelo cliente, para efeitos de obtenção do
            CPE, compromete-se, desde já, a apresentar esse documento à E-REDES - Distribuição de Eletricidade, S.A.
          </div>
        </div>
      </div>

      <!-- ERROR MESSAGES -->
      <div
        class="alert alert-danger text-center"
        *ngIf="f.zipcode && f.zipcode.errors && f.zipcode.errors.invalidPostalCode"
      >
        <div>Código Postal Inválido</div>
      </div>

      <!-- ACTION BUTTONS -->
      <div class="request__cpe__filter__button">
        <button type="button" class="request__cpe__filter__button-left" (click)="onReset()">Limpar</button>
        <button type="submit" class="request__cpe__filter__button-right" [disabled]="!viewModel.cpeForm.valid">
          Pesquisar
        </button>
      </div>
    </form>
  </div>
</section>

<ng-template #templateCPEfound>
  <!-- Modal - Found a code successfully -->
  <div class="custom-modal-content" *ngIf="!viewModel.hasCopyToClipboard">
    <i class="icon icon--x-large icon--cpe custom-modal-content-icon-primary"></i>

    <div class="custom-modal-content-info">
      <span class="custom-modal-content-info-title">CPE encontrado com sucesso</span>
      <span class="custom-modal-content-info-body">Código: {{ viewModel.cpeCode }}</span>
    </div>

    <div class="custom-modal-content-horizontal-line"></div>
    <div class="custom-modal-content-footer">
      <button class="custom-modal-content-footer-btn" (click)="copyCPEtoClipboard()">Copiar código</button>
    </div>
  </div>

  <!-- Modal - Copy the code for the clipboard successfully  -->
  <div class="custom-modal-content" *ngIf="viewModel.hasCopyToClipboard">
    <i class="icon icon--x-large icon--check custom-modal-content-icon-green"></i>

    <div class="custom-modal-content-info">
      <span class="custom-modal-content-info-title">Código CPE copiado com sucesso</span>
    </div>
  </div>
</ng-template>

<!-- Modal - Not found cpe code  -->
<ng-template #templateCPEnotFound>
  <div class="custom-modal-content" *ngIf="!viewModel.hasCopyToClipboard">
    <i class="icon icon--x-large icon--alert custom-modal-content-icon-primary"></i>

    <div class="custom-modal-content-info">
      <span class="custom-modal-content-info-title">Não existem resultados para a pesquisa efetuada</span>
      <span class="custom-modal-content-info-body"
        >Confirme se o que escreveu está correto ou tente uma pesquisa diferente.</span
      >
    </div>

    <div class="custom-modal-content-horizontal-line"></div>
    <div class="custom-modal-content-footer">
      <button class="custom-modal-content-footer-btn" (click)="resetSearch()">Repetir pesquisa</button>
    </div>
  </div>
</ng-template>
